import { render } from "./touristIndivid.vue?vue&type=template&id=380813da&scoped=true"
import script from "./touristIndivid.vue?vue&type=script&lang=js"
export * from "./touristIndivid.vue?vue&type=script&lang=js"

import "./touristIndivid.vue?vue&type=style&index=0&id=380813da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380813da"]])

export default __exports__